export const addIdentifierToShots = (shots) =>
    shots.map((shot, i) => ({ ...shot, identifier: i + 1 }));
